
 

 

 

 
class ModuleData 
{
    
        Id: string;
    
        Name: string;
    
        BaseUrl: string;
    
}
 
export default ModuleData;
 




